import { Components, Theme } from '@mui/material';

import { AdditionalColors } from '@/theme/PaletteOverrides.ts';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    filled: true;
    inverted: true;
    outlined: true;
  }

  interface ChipPropsColorOverrides extends AdditionalColors {}
}

const chipTransition = '300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';

export const chipComponentOverrides: Components<Theme>['MuiChip'] = {
  variants: [],
  styleOverrides: {
    root: ({ theme, ownerState: { variant, color } }) => {
      if (variant === 'inverted' && color && color !== 'default') {
        return {
          backgroundColor: theme.palette[color].contrastText,
          color: theme.palette[color].dark,
        };
      }
      return undefined;
    },
    clickable: ({ theme, ownerState: { variant, color } }) => {
      if (variant === 'inverted' && color && color !== 'default') {
        return {
          '&:hover': {
            color: theme.palette[color].contrastText,
            transition: `color ${chipTransition}, background-color ${chipTransition}, box-shadow ${chipTransition}`,
          },
        };
      }
      return undefined;
    },
  },
};
